var activeElements = unescape(Cookies.get("actElems"));
if (activeElements == "null") { activeElements = ""; }
var today = new Date();
var expire = new Date();

function swCss(elem) {
	var parElem = elem.parentNode;
	var elemId = parElem.id;
	if (parElem.className == '' || parElem.className == 'liClosed' || parElem.className == 'liBullet') {
		parElem.className = 'open'
		var stavajiciElem = document.getElementById(activeElements);
		if (stavajiciElem != undefined && stavajiciElem != null)	{
			stavajiciElem.className = '';
		}
		activeElements = elemId;
	}
	
	expire.setTime(today.getTime() + 3600000*24*-1);
	document.cookie = "actElems"+"=;expires="+expire.toGMTString();

	expire.setTime(today.getTime() + 3600000*24*1000);
	document.cookie = "actElems"+"="+escape(activeElements)+";expires="+expire.toGMTString()+"; path=/";

	elem.blur();
//	return false;
}

function RSitem (index, name, code, deep, sub) {
	this.index = index;
	this.name = name;
	this.code = code;
	this.sub = sub;
	this.deep = deep;
}

function publicRSitem () {
	var obj = document.getElementById('cat' + this.deep);
	var oOption = document.createElement("OPTION");
	obj.options [this.index] = null;
	oOption.text = this.name;
	oOption.value = this.index;
	obj.options [obj.options.length] = oOption;
}

function displayRSsubItems () {			
	if (this.sub != '') {
		var subs = this.sub.split (',');
		for (var i in subs) {
			items[subs[i]].publicItem ();
		}
	}
}

RSitem.prototype.publicItem = publicRSitem;
RSitem.prototype.displaySubItems = displayRSsubItems;

function displayCat (id) {
	var obj = document.getElementById('cat'+id);
	for (var i = id+1; i<=3; i++) {
		var panel = document.getElementById('cat'+i);
		if (panel != undefined) {
			for (var j=panel.options.length-1;j>=0;j--) {
				panel.options[j] = null;
			}
		}
	}
	for(i=0;i < obj.options.length;i++){
		if(obj.options[i].selected==true) {
			items[obj.options[i].value].displaySubItems();
		}
	}
}

function submitCat () {
	var pole = new Array ();
	for (var i=3; i>=1; i--) {
		var panel = document.getElementById("cat"+i);
		if (panel != undefined) {
			if (panel.selectedIndex != -1) {					
				for (var j = 0; j < panel.options.length; j++) {
					if (panel.options[j].selected) {						
						pole [pole.length] = items[panel.options[j].value].code;
					}
				}
				document.getElementById('kat').value = pole;
				break;
			}
		}
	}
}

function selectAll (status) {
	if (status) {
		var panel = document.getElementById("cat1");
		for (var j = 0; j < panel.options.length; j++) {
			panel.options[j].selected = true;
		}
		for (var i = 2; i<=3; i++) {
			var panel = document.getElementById('cat'+i);
			for (var j=panel.options.length-1;j>=0;j--) {
				panel.options[j] = null;
			}
		}
	}

	return false;
}

function sellectAllGroup(sbId) {
	var sbElem = document.getElementById(sbId);
	if (sbElem != null)	{
		for (var j = 0; j < sbElem.options.length; j++) {
			sbElem.options[j].selected = true;
		}
	}

	return false;
}

function changeTree(newTree) {
	document.getElementById('selTree').className = "old";
	document.getElementById('loadTree').className = "";
	
	if (newTree == 1) {
		document.getElementById('selTree1').className = "sortiment selTree1";
		document.getElementById('selTree2').className = "selTree";
	} else {
		document.getElementById('selTree1').className = "sortiment selTree";
		document.getElementById('selTree2').className = "selTree1";
	}
	getWebURL('/index.php?tName=indexclear;io=changeTree;newTree='+newTree, 'shopTree');
}
function closeWindow(winId) {
	document.getElementById(winId).className = "old";
	return false;
}

function newSearchWindow(winId) {
	document.getElementById('searchWindow').className = "win";
	document.getElementById("searchContent1").className = "old";
	document.getElementById("searchContent2").className = "old";
	document.getElementById("searchContent" + winId).className = "";
	return false;
}

function setSearchFilter() {
	var divElemClass = document.getElementById("searchContent1").className;

	var winId = (divElemClass == "old") ? 2 : 1;
	
	if (winId == 1)	{
		// udelame okno 1 - Vyhledavaci skupiny
		var sbArray = new Array('brand', 'ucelp', 'material', 'barva', 'cilskup', 'podtechnol');
		for (var sbKey in sbArray)	{
			var setText = '';
			var setValues = '';
			var sbElem = document.getElementById(sbArray[sbKey]);
			if (sbElem != null)	{
				if (sbElem.selectedIndex != -1) {
					for (var j = 0; j < sbElem.options.length; j++) {
						if (sbElem.options[j].selected)	{
							if (setText.length > 0) {
								setText += '&nbsp;| ';
							}
							setText += sbElem.options[j].text;
						}
					}

					var elemText = document.getElementById(sbArray[sbKey]+'SearchText');
					if (elemText != null)	{
						elemText.innerHTML = setText;
					}
				}
			}
		}
	} else {
		// udelame okno 2 - Stromove kategorie
		for (var i=3; i>=1; i--) {
			var panel = document.getElementById("cat"+i);
			if (panel.selectedIndex != -1) {					
				var setText = '';
				for (var j = 0; j < panel.options.length; j++) {
					if (panel.options[j].selected) {
						if (setText.length > 0) {
							setText += '&nbsp;| ';
						}
						setText += panel.options[j].text.replace(/ \([0-9]+\)/g, '');
					}
				}

				var elemText = document.getElementById('treeSelected');
				if (elemText != null)	{
					elemText.innerHTML = setText;
				}
				break;
			}
		}
	}


	closeWindow('searchWindow');
	return false;
}

function changeNchDivision(nchDivision) {
	var today = new Date();
	var expire = new Date();

	expire.setTime(today.getTime() + 3600000*24*-1);
	document.cookie = "nchdivision"+"=;expires="+expire.toGMTString();

	expire.setTime(today.getTime() + 3600000*24*100000);
	document.cookie = "nchdivision"+"="+escape(nchDivision)+";expires="+expire.toGMTString()+"; path=/";

	window.location.replace("/online");
}


function changeOrderItem(polId, orderId) {
	var mnozstvi = document.getElementById('polZmenForm' + polId).value;
	window.location.replace('/index.php?io=objPolZmen&id_objio='+orderId+'&id_objio_pol='+polId+'&mnozstvi='+mnozstvi);
}

function checkEnter(e, polId, orderId) {
	var keynum;
	var keychar;

	if(window.event) {
		// IE
		keynum = e.keyCode
	} else if(e.which) {
		// Netscape/Firefox/Opera
		keynum = e.which
	}
	
	if (keynum == 13)	{
		changeOrderItem(polId, orderId);
		return false;
	}
}

var activeNahled = null;
function switchKalendarNahled(elem) {
	var mainNahled = document.getElementById('mainNahled');
	if (mainNahled != undefined) {
		mainNahled.src = elem.src;
		elem.className = "active";
		if (activeNahled != null) {
			activeNahled.className = null;
		}
		activeNahled = elem;
	}
}
